import React, { useEffect } from "react";
import ManageAccountTab from "../ManageAccountTab";
import ErrorBoundary from "../../common/ErrorBoundary";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../../store";
import { useCheckAnyServiceActive } from "../../../util/CommonServices";
import * as UserServiceAction from "../../../store/userService/actions";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { IServiceCategory } from "../../../store/userService/types";
import { ITUService } from "../../../store/dashboardService/types";
import ServiceCategory from "./ServiceCategory";
import { Link } from "react-router-dom";
import * as services from "../../../store/service";
import LogoContainer from "../../common/LogoContainer";
import * as LoginActions from "../../../store/loginService/actions";
import { useTranslation } from "react-i18next";
import TUAuthentication from "../../Credit/Auth/TUAuthentication";

const MyServices = (props: any) => {
    const dispatch = useDispatch();
    const requestUserService = () => dispatch(UserServiceAction.actionCreators.requestUserService());
    const requestUserServiceReload = (reloadData: boolean) => dispatch(UserServiceAction.actionCreators.requestUserService(reloadData));
    const serviceCategories: IServiceCategory[] = useSelector((state: ApplicationState) =>
        state.userServiceState && state.userServiceState.serviceCategories ? state.userServiceState.serviceCategories : []
    );
    const loadingServices: boolean = useSelector((state: ApplicationState) =>
        state.userServiceState && state.userServiceState.loadingServices ? state.userServiceState.loadingServices : false
    );
    const tuServices: ITUService[] = useSelector((state: ApplicationState) =>
        state.tuServicesState && state.tuServicesState.tuServices ? state.tuServicesState.tuServices : []
    );
    const loadingTUServices: boolean = useSelector((state: ApplicationState) =>
        state.tuServicesState && state.tuServicesState.loadingServices ? state.tuServicesState.loadingServices : false
    );
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const updateServiceDetails = () => dispatch(LoginActions.actionCreators.updateSmbServiceDetails());
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const isAvastId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2611
                ? true
                : false
            : false
    );
    const isAVGId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2659
                ? true
                : false
            : false
    );
    const isAVGTestId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2662
                ? true
                : false
            : false
    );
    const preferencedLanguage = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.preferencedLanguage ? state.loggedInUser.userInfo?.preferencedLanguage : "en"
    );

    const recallMyServicesApi = JSON.parse(sessionStorage.getItem('reloadUserServices') || 'false');

    useEffect(() => {
        const initialUrl = window.location.origin + "/app/manage-account/my-account";
        sessionStorage.setItem("initialUrl", encodeURIComponent(initialUrl));
        const languageInSession = sessionStorage.getItem('language');

        if (recallMyServicesApi) {
            requestUserServiceReload(true);
        } else if (!languageInSession) {
            requestUserService();
        } else {
            if (preferencedLanguage === languageInSession) {
                requestUserServiceReload(true);
                sessionStorage.setItem('language', '');
            }
        }
        if (renderSiteInIFrame) {
            updateServiceDetails();
        }
        if (isAvastId) {
            document.title = "Avast | Manage Profile | My Services";
        }
        if (isAVGId || isAVGTestId) {
            document.title = "AVG | Manage Profile | My Services";
        }
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    useEffect(() => {
        if (accountInfo && accountInfo.isSSOUser) {
            services.getPackageUpdateForSSO().then((res) => {
                if (res.isPackageUpdatedForSSOUser) {
                    requestUserServiceReload(true);
                }
            });
        }
    }, [accountInfo && accountInfo.isSSOUser]);

    return (
        <React.Fragment>
            <TUAuthentication />

            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="my-services-page" tabIndex={-1}>
                        {(isAvastId || isAVGId || isAVGTestId) ? "Manage Profile" : tLang("manageAccount.title")}
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <ManageAccountTab selectedTab="3" isAvastId={isAvastId || isAVGId || isAVGTestId} />

            {useCheckAnyServiceActive() ? (
                <div className="row" id="content">
                    {loadingServices || loadingTUServices ? (
                        <div className="col-xs">
                            <div className="box offset-padding loading"></div>
                        </div>
                    ) : (
                        <div className="col-xs">
                            {serviceCategories.map((serviceCategory, index) => {
                                return (
                                    <ErrorBoundary componentName="ServiceCategory" type="hideError" replaceDefaultContent={false} errorMsg="" key={index}>
                                        <ServiceCategory serviceCategory={serviceCategory} tuServices={tuServices} />
                                    </ErrorBoundary>
                                );
                            })}
                        </div>
                    )}
                </div>
            ) : (
                <div className="row margin-bottom-s" id="content">
                    <div className="box col-xs-12">
                        <div className="box-content">
                            <div className="data-grid" role="grid" style={{ backgroundColor: "#F2F6F9", width: "100%", padding: "10px" }}>
                                <div role="row" className="box-header col-xs-12 col-sm-12 ">
                                    <div role="gridcell" className="content-sub-title text-align-center">
                                        <div className="monitoring-alert-icon" style={{ fontSize: "40px" }}>
                                            <em className="las la-exclamation-circle "></em>
                                        </div>
                                    </div>
                                </div>
                                    <div role="row" className="box-content text-align-center">
                                       <div role="gridcell">
                                            <p>{tLang("dashboard.noServiceActive.message")}</p>
                                            <p>
                                                <Link to="/manage-account/protection-plan" className="default_link">
                                                    {tLang("dashboard.noServiceActive.protectionPlanLink")}
                                                </Link>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            )}
        </React.Fragment>
    );
};

export default MyServices;
